angular.module('NiacsProjectApp.controllers-step4', [
])
.controller('AddEditApproachCtrl',['$scope','$uibModalInstance','strategy','approach',
    function($scope,$uibModalInstance,strategy,approach){
        $scope.dismiss = $uibModalInstance.dismiss;
        $scope.strategy = strategy;
        $scope.approach = approach;
        $scope.save = function() {
            $uibModalInstance.close($scope.approach);
        };
}])
.controller('AddEditTacticCtrl',['$scope','$uibModalInstance','NiacsStrategyService','project','tactic',
    function($scope,$uibModalInstance,NiacsStrategyService,project,tactic){
        $scope.dismiss = $uibModalInstance.dismiss;
        NiacsStrategyService.getSourceTree().then(function(tree) {
            var getSector = function(approach) {
                if(approach.strategy) {
                    var strat = tree.getStrategy(approach.strategy);
                    if(strat) {
                        return strat.getSource();
                    }
                }
            };
            $scope.getApproaches = function(approach) {
                if(approach.strategy) {
                    var strat = tree.getStrategy(approach.strategy);
                    return strat ? strat.approaches : [];
                }
                return [];
            };
            var sourceNames = tree.getEnabledSourceNames();
            // if the project does not explicitly use FAR1 then remove it as an option, it's deprecated.
            if(project.strategy_sources.indexOf('niacs_strategy') === -1) {
                sourceNames = sourceNames.filter(function(name) { return name !== 'niacs_strategy'; });
            }
            // sort sourceNames to keep sectors the project is in at the top of the selection list
            sourceNames.sort(function(a,b) {
                var a_in = project.strategy_sources.indexOf(a) !== -1;
                var b_in = project.strategy_sources.indexOf(b) !== -1;
                if(a_in && b_in) {
                    return 0;
                }
                if(a_in || b_in) {
                    return a_in ? -1 : 1;
                }
                return a.localeCompare(b);
            });
            $scope.sectorChanged = function(approach) {
                if(approach) {
                    delete approach.$strategies;
                    if(approach.$sector) {
                        approach.$strategies = tree.getStrategiesForSource(approach.$sector);
                    }
                }
            };
            // initialize things
            tactic.approaches.forEach(function(approach) {
                var sector = getSector(approach);
                if(sector) {
                    approach.$sector = sector;
                    $scope.sectorChanged(approach);
                }
            });
            $scope.sectorMenuUrl = function(sector) {
                var s = tree.getSource(sector);
                return 'niacs-strategies' + (s ? '/'+s.getSourceAlias() : '');
            };
            $scope.sectors = sourceNames.map(function(name) { return tree.getSource(name); });
        });

        $scope.tactic = tactic;
        if(!tactic.approaches) {
            tactic.approaches = [{}];
        }

        $scope.validApproaches = function() {
            for(var i = 0; i < $scope.tactic.approaches.length; i++) {
                if(!$scope.tactic.approaches[i].strategy || !$scope.tactic.approaches[i].approach) {
                    return false;
                }
            }
            return true;
        };
        $scope.addApproach = function() {
            $scope.tactic.approaches.push({});
        };
        $scope.removeApproach = function(idx) {
            if(idx < $scope.tactic.approaches.length) {
                $scope.tactic.approaches.splice(idx,1);
            }
        };
        $scope.strategyChanged = function(approach) {
            if(approach) {
                delete approach.approach;
            }
        };
        $scope.save = function() {
            $uibModalInstance.close($scope.tactic);
        };
}])
.controller('ActionsCtrl',['$scope','$routeParams','$filter','$uibModal','ProjectService','AutoSaveService','NiacsStrategyService','ShowHideService','DialogService',
    function($scope,$routeParams,$filter,$uibModal,ProjectService,AutoSaveService,NiacsStrategyService,ShowHideService,DialogService){
        $scope.hasObjectivesWithTactics = function(context) {
            var objectives = context ? niacs.collectObjectives(context) : [],i;
            if(objectives.length) {
                for(i = 0; i < objectives.length;i++) {
                    if(objectives[i].tactics && objectives[i].tactics.length) {
                        return true;
                    }
                }
            }
            return false;
        };
        $scope.overviewTacticVisit = function(tactic) {
            if(tactic) {
               $scope.visit('actions','adaptation_tactics','tactic.'+tactic.id);
            }
        };
        function saveProject() {
            ProjectService.save().then(getContexts);
        }
        $scope.tacticRefVisibility = {};
        $scope.tacticDetailVisibility = {};
        $scope.initTacticRefVisibility = function(tactic) {
            if(typeof($scope.tacticRefVisibility[tactic.id]) == 'undefined') {
                $scope.tacticRefVisibility[tactic.id] = tactic.$refCount ? true : false;
            }
        };
        function editTactic(tactic) {
            $uibModal.open({
              templateUrl: 'partials/dialogs/add-edit-tactic.html',
              controller: 'AddEditTacticCtrl',
              windowClass: 'niacs-tactic-dialog',
              keyboard: false,
              backdrop: 'static',
              resolve:{
                project: function() { return $scope.project; },
                tactic: function() { return JSON.parse(JSON.stringify(tactic)); }
              }
            }).result.then(function(t){
                angular.extend(tactic,t);
                saveProject();
            },function(){});
        }
        function deleteTactic(tactic) {
            var refCount = 0;
            angular.forEach($scope.goals,function(goal){
                angular.forEach(goal.objectives,function(objective){
                    if(objective.tactics && niacs.findById(objective.tactics,tactic.id) != null) {
                        refCount++;
                    }
                });
            });
            function doRemove() {
                // find all tactic refs and remove them.
                angular.forEach($scope.goals,function(goal){
                    angular.forEach(goal.objectives,function(objective){
                        if(objective.tactics && niacs.removeById(objective.tactics,tactic.id)) {
                            niacs.debug("dropped tacticRef from objective",objective);
                        }
                    });
                });
                // remove the tactic from the project.
                if(niacs.removeById($scope.project.tactics,tactic.id)) {
                    niacs.debug("dropped tactic from project",tactic);
                    saveProject();
                }
            }
            var dialogContents = {
                message: 'Are you sure you want to remove this tactic?',
                warning: 'This cannot be undone.',
                okText: 'Yes, remove this tactic',
                cancelText: 'No, keep this tactic',
                conditions: []
            };
            if(refCount > 0) {
                dialogContents.conditions.push(refCount+' objectives have been marked as applicable for this tactic.');
            }
            DialogService.safe(dialogContents).then(function() {
                niacs.info('user confirmed deletion of tactic.');
                doRemove();
            });
        }
        // gets icons specific to a tactic object
        function getTacticControls(tactic) {
            return [{
                icon: 'pencil',
                action: function() { editTactic(tactic); },
                tooltip: 'Edit Tactic'
            },{
                icon: 'times-circle',
                action: function() { deleteTactic(tactic); },
                tooltip: 'Delete Tactic'
            }];
        }
        $scope.addTactic = function(/* strategy,approach */) {
            $uibModal.open({
              templateUrl: 'partials/dialogs/add-edit-tactic.html',
              controller: 'AddEditTacticCtrl',
              windowClass: 'niacs-tactic-dialog',
              keyboard: false,
              backdrop: 'static',
              resolve:{
                project: function() { return $scope.project; },
                tactic: function() { return {/*strategy: strategy.id, approach: approach.id*/}; }
              }
            }).result.then(function(t){
                t.id = niacs.guid();
                if(!$scope.project.tactics) {
                    $scope.project.tactics = [];
                }
                $scope.project.tactics.push(t);
                saveProject();
                // the new tactic may have siblings in its accordion
                // explicitly make it so the new tactic is the one that's open.
                /*
                var uniqueId = "ap."+approach.id+".tactic."+t.id;
                ShowHideService.get(uniqueId,true).show = true;
                ShowHideService.accordionChange(uniqueId);
                */
               var uniqueId = "tactic."+t.id;
               ShowHideService.get(uniqueId,true).show = true;
               ShowHideService.accordionChange(uniqueId);
            },function(){});
        };
        $scope.getTacticRef = function(objective,tactic) {
            if(objective.tactics) {
                for(var i = 0; i < objective.tactics.length; i++) {
                    if(objective.tactics[i].id == tactic.id) {
                        return objective.tactics[i];
                    }
                }
            }
            return {id: tactic.id, applicable: false}; // new empty reference.
        };
        $scope.changeApplicability = function(objective,tacticRef) {
            niacs.debug("changeApplicability",objective,tacticRef);
            // for simplicity always just remove and re-add the tactic reference.
            if(objective.tactics) {
                niacs.removeById(objective.tactics,tacticRef.id);
            }
            if(tacticRef.applicable) {
                tacticRef.recommended = true;
                if(!objective.tactics) {
                    objective.tactics = [];
                }
                objective.tactics.push(tacticRef);
            }
            saveProject();
        };
        $scope.changeRecommendation = function(tacticRef) {
            niacs.debug("changeRecommendation",tacticRef);
            saveProject();
        };
        /* no longer supporting custom approaches but leaving code in case it comes back.
        $scope.isCustomApproach = function(approach) {
            return approach && angular.isString(approach.id);
        };
        $scope.editCustomApproach = function(strategy,approach) {
            if(approach && angular.isNumber(approach.id)) {
                $log.error("Attempt to edit non-custom approach.");
                return;
            }
            niacs.info("editCustomApproach",approach);
            $uibModal.open({
              templateUrl: 'partials/dialogs/add-edit-custom-approach.html',
              controller: 'AddEditApproachCtrl',
              windowClass: 'niacs-custom-cis-dialog',
              keyboard: false,
              backdrop: 'static',
              resolve:{
                strategy: function() { return strategy; },
                approach: function() { return angular.copy(approach); }
              }
            }).result.then(function(editedApproach){
                approach.name = editedApproach.name;
                saveProject();
            },function(){});
        };
        $scope.addCustomApproach = function(strategy) {
            $uibModal.open({
              templateUrl: 'partials/dialogs/add-edit-custom-approach.html',
              controller: 'AddEditApproachCtrl',
              windowClass: 'niacs-custom-cis-dialog',
              keyboard: false,
              backdrop: 'static',
              resolve:{
                strategy: function() { return strategy; },
                approach: function() { return {strategy: strategy.id, id: niacs.guid()}; }
              }
            }).result.then(function(newApproach){
              if(!$scope.project.custom_approaches) {
                $scope.project.custom_approaches = [];
              }
              $scope.project.custom_approaches.push(newApproach);
              saveProject();
            },function(){});
        };
        */
        function getContexts() {
            var project = $scope.project,contexts,objectives,i,j,tmp;
            if(project && project.$vuln_region && project.$vuln_region.$units) {
                //unit in project.units | inflate:project.$vuln_region.$units
                contexts = [].concat($filter('inflate')(project.units,project.$vuln_region.$units));
                if($scope.contexts) {
                    for(i = 0; i < contexts.length; i++) {
                        $scope.contexts[i] = contexts[i];
                    }
                } else {
                    $scope.contexts = contexts;
                }
                $scope.goals = niacs.collectGoals(project,true);
                objectives = niacs.collectObjectives(project,true);
                $scope.objectiveCount = objectives.length;
                for(i = 0; project.tactics && i < project.tactics.length; i++) {
                    project.tactics[i].$refCount = 0;
                    project.tactics[i].$controls = getTacticControls(project.tactics[i]);
                }
                // count references to tactics
                for(i = 0; i < objectives.length; i++) {
                    for(j = 0; objectives[i].tactics && j < objectives[i].tactics.length; j++) {
                        if((tmp = niacs.findById(project.tactics,objectives[i].tactics[j].id)) != null) {
                            tmp.$refCount++;
                        }
                    }
                }
            }
        }
        $scope.isSaving = AutoSaveService.isSaving;
        $scope.$watch('project.$vuln_region.$units',getContexts);
        $scope.$watch('project.$updateCount',getContexts);
        ProjectService.get($routeParams,'ActionsCtrl',function(project){
            $scope.project = project;
            NiacsStrategyService.getProjectSourceResources(project).then(function(resources){
                $scope.strategyResources = resources;
            });
            NiacsStrategyService.getSourceTree().then(function(tree) {
                $scope.strategyName = function(sid) {
                  var strat = tree.getStrategy(sid);
                  return strat ? tree.getStrategyLabel(strat,$scope.project) : '';
                };
                $scope.approachName = function(sid,aid) {
                  var app = tree.getApproach(sid,aid);
                  return app ? app.name : "";
                };
            });
        });
}]);
